export const convertibleValuationConstants = {
  CONVERTIBLE_VALUATION_CREATE_LOADING: 'CONVERTIBLE_VALUATION_CREATE_LOADING',
  CONVERTIBLE_VALUATION_CREATE_SUCCESS: 'CONVERTIBLE_VALUATION_CREATE_SUCCESS',
  CONVERTIBLE_VALUATION_CREATE_FAILURE: 'CONVERTIBLE_VALUATION_CREATE_FAILURE',
  CONVERTIBLE_VALUATION_ERROR_RELOAD: 'CONVERTIBLE_VALUATION_ERROR_RELOAD',

  CONVERTIBLE_VALUATION_LIST_LOADING: 'CONVERTIBLE_VALUATION_LIST_LOADING',
  CONVERTIBLE_VALUATION_LIST_SUCCESS: 'CONVERTIBLE_VALUATION_LIST_SUCCESS',
  CONVERTIBLE_VALUATION_LIST_FAILURE: 'CONVERTIBLE_VALUATION_LIST_FAILURE',

  CONVERTIBLE_VALUATION_EDIT_LOADING: 'CONVERTIBLE_VALUATION_EDIT_LOADING',
  CONVERTIBLE_VALUATION_EDIT_SUCCESS: 'CONVERTIBLE_VALUATION_EDIT_SUCCESS',
  CONVERTIBLE_VALUATION_EDIT_FAILURE: 'CONVERTIBLE_VALUATION_EDIT_FAILURE',

  CONVERTIBLE_VALUATION_DELETE_LOADING: 'CONVERTIBLE_VALUATION_DELETE_LOADING',
  CONVERTIBLE_VALUATION_DELETE_SUCCESS: 'CONVERTIBLE_VALUATION_DELETE_SUCCESS',
  CONVERTIBLE_VALUATION_DELETE_FAILURE: 'CONVERTIBLE_VALUATION_DELETE_FAILURE'
};
